import http from "../http-common";

class TopArticlesForHomePage {
  getTopArticlesForHomePage(noOfRows: number) {
    return http.get(`articles/top/${noOfRows}`);
  }
}
export default new TopArticlesForHomePage();
